import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { ISpecialty } from '../types/interfaces/ISpecialties';

export async function getSpecialties(): Promise<ApiResponse<ISpecialty[]>> {
  return apiClient.get<ISpecialty[]>('/specialties');
}

export async function getSpecialtyById(id: string): Promise<ApiResponse<ISpecialty>> {
  return apiClient.get<ISpecialty>(`/specialties/${id}`);
}

export async function createSpecialty(
  data: Omit<ISpecialty, 'id' | 'createdAt' | 'updatedAt'>
): Promise<ApiResponse<ISpecialty>> {
  return apiClient.post<ISpecialty>('/specialties', data);
}

export async function updateSpecialty(
  id: string,
  data: Partial<ISpecialty>
): Promise<ApiResponse<ISpecialty>> {
  return apiClient.put<ISpecialty>(`/specialties/${id}`, data);
}

export async function deleteSpecialty(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`/specialties/${id}`);
}

export async function toggleSpecialtyStatus(id: string): Promise<ApiResponse<ISpecialty>> {
  return apiClient.patch<ISpecialty>(`/specialties/${id}/toggle-status`);
}
